/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { toolsetsSetUserSessionIssuer } from "../funcs/toolsetsSetUserSessionIssuer.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Toolset } from "../models/components/toolset.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  SetToolsetUserSessionIssuerRequest,
  SetToolsetUserSessionIssuerSecurity,
} from "../models/operations/settoolsetusersessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type SetToolsetUserSessionIssuerMutationVariables = {
  request: SetToolsetUserSessionIssuerRequest;
  security?: SetToolsetUserSessionIssuerSecurity | undefined;
  options?: RequestOptions;
};

export type SetToolsetUserSessionIssuerMutationData = Toolset;

export type SetToolsetUserSessionIssuerMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * setUserSessionIssuer toolsets
 *
 * @remarks
 * Link a toolset to a user_session_issuer (or pass null to unlink). The user_session_issuer must already exist in the caller's project.
 *
 * Deprecated: use mcpServers.update instead.
 *
 * @deprecated method: This will be removed in a future release, please migrate away from it as soon as possible.
 */
export function useSetToolsetUserSessionIssuerMutation(
  options?: MutationHookOptions<
    SetToolsetUserSessionIssuerMutationData,
    SetToolsetUserSessionIssuerMutationError,
    SetToolsetUserSessionIssuerMutationVariables
  >,
): UseMutationResult<
  SetToolsetUserSessionIssuerMutationData,
  SetToolsetUserSessionIssuerMutationError,
  SetToolsetUserSessionIssuerMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildSetToolsetUserSessionIssuerMutation(client, options),
    ...options,
  });
}

export function mutationKeySetToolsetUserSessionIssuer(): MutationKey {
  return ["@gram/client", "toolsets", "setUserSessionIssuer"];
}

export function buildSetToolsetUserSessionIssuerMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: SetToolsetUserSessionIssuerMutationVariables,
  ) => Promise<SetToolsetUserSessionIssuerMutationData>;
} {
  return {
    mutationKey: mutationKeySetToolsetUserSessionIssuer(),
    mutationFn: function setToolsetUserSessionIssuerMutationFn({
      request,
      security,
      options,
    }): Promise<SetToolsetUserSessionIssuerMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(toolsetsSetUserSessionIssuer(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
